import FooterComponent from "../../components/Footer";
import HeaderComponent from "../../components/Header";
import NewcomersPropertiesSection from "./components/NewcomersSection";
import AnunciatePropertySection from "./components/AnunciatePropertySection";
import FeedbackSection from "./components/FeedbackSection";
import HomeFaqSection from "./components/HomeFaqSection/HomeFaqSection";
import MapSection from "./components/MapSection";
import RentJourneySection from "./components/RentJourneySection";
import SearchSection from "./components/SearchSection";
import React from "react";
import AdvantagesSection from "./components/AdvantagesSection";
import { Wrapper } from "./styles";
import PublicPageHelmet from "../../seo/PublicPageHelmet";

function Home() {
  return (
    <>
      <PublicPageHelmet pathname="/" />
      <HeaderComponent showAboutUs hasBorder />
      <Wrapper>
        <SearchSection />
        <NewcomersPropertiesSection />
        <RentJourneySection />
        <AnunciatePropertySection />
        <AdvantagesSection />
        <MapSection />
        <FeedbackSection />
        <HomeFaqSection />
      </Wrapper>
      <FooterComponent />
    </>
  );
}

export default Home;
